export const initHousesSwiper = () => {
  if (window.innerWidth > 991) return;
  const swiperElement = document.querySelector(".houses-swiper-mobile");
  if (
    !swiperElement ||
    !window.SwiperGlobal ||
    swiperElement.classList.contains("swiper-initialized")
  )
    return;

  new window.SwiperGlobal(swiperElement, {
    slidesPerView: "auto",
    spaceBetween: 0,
    grabCursor: true,
    watchOverflow: true,
    pagination: false,
    navigation: {
      nextEl: swiperElement.querySelector(".swiper-button-next"),
      prevEl: swiperElement.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      992: {
        enabled: false,
      },
    },
  });
};
export const initHouseGallerySlider = () => {
  const wrappers = document.querySelectorAll(".house-gallery-wrapper");

  wrappers.forEach((wrapper) => {
    const navEl = wrapper.querySelector(".house-thumbs-swiper");
    const mainEl = wrapper.querySelector(".house-main-swiper");

    if (!mainEl || !navEl || !window.SwiperGlobal) return;

    const galleryNav = new window.SwiperGlobal(navEl, {
      slidesPerView: "auto",
      spaceBetween: 8,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      centerInsufficientSlides: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
    });

    const galleryMain = new window.SwiperGlobal(mainEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 600,
      autoHeight: true,
      grabCursor: true,
      navigation: {
        nextEl: wrapper.querySelector(".gallery-arrow-next"),
        prevEl: wrapper.querySelector(".gallery-arrow-prev"),
      },
      thumbs: {
        swiper: galleryNav,
      },
      breakpoints: {
        992: {
          autoHeight: false,
        },
      },
      on: {
        slideChange: function () {
          const activeIndex = this.activeIndex;

          if (galleryNav) {
            galleryNav.slideTo(activeIndex);

            navEl.querySelectorAll(".swiper-slide").forEach((slide, idx) => {
              slide.classList.toggle(
                "swiper-slide-thumb-active",
                idx === activeIndex,
              );
            });
          }
        },
      },
    });

    const firstThumb = navEl.querySelector(".swiper-slide");
    if (firstThumb) {
      firstThumb.classList.add("swiper-slide-thumb-active");
    }

    navEl.querySelectorAll(".swiper-slide").forEach((slide, index) => {
      slide.addEventListener("click", () => {
        galleryMain.slideTo(index);
      });
    });
  });
};
